<template>
  <b-form @submit.prevent="guardar">
    <b-form-row>
      <b-form-group class="col-12">
        <label for="cas_no">
          CAS No.
        </label>
        <b-form-input id="cas_no"
                      name="cas_no"
                      data-vv-as=" "
                      v-validate="'max:50'"
                      v-model="selectedSeccion3.cas_no"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion3.usos_identificados')"
        />
      </b-form-group>
      <b-form-group class="col-12">
        <label for="tipo_producto">
          Tipo de producto
        </label>
        <b-form-input id="tipo_producto"
                      name="tipo_producto"
                      data-vv-as=" "
                      v-validate="'max:10'"
                      v-model="selectedSeccion3.tipo_producto"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion3.tipo_producto')"
        />
      </b-form-group>
      <b-form-group class="col-12">
        <label for="descripcion_compuesto">
          Descripción del compuesto
        </label>
        <b-form-textarea id="descripcion_compuesto"
                      name="descripcion_compuesto"
                      data-vv-as=" "
                      v-validate="'max:10'"
                      v-model="selectedSeccion3.descripcion_compuesto"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion3.descripcion_compuesto')"
        />
      </b-form-group>
    </b-form-row>
    <!-- COMPONENTES -->
    <b-form-row>
      <b-card header="Componentes" class="col-12">
        <b-row class="float-right mt-0">
          <b-col sm="4">
            <b-button
              type="button"
              size="sm"
              class="mb-2"
              style="width: 200px !important;"
              variant="primary"
              @click="crearComponente()"
            >
              Crear componente
            </b-button>
          </b-col>
        </b-row>
        <!-- TABLA DE COMPONENTES -->
        <b-table responsive
                 small
                 thead-class="table-active"
                 :items="componentes_detalle"
                 :fields="columnas" >
          <template v-slot:cell(compuesto)="row">
            {{ row.item.compuesto }}
          </template>
          <template v-slot:cell(cas)="row">
            {{ row.item.cas }}
          </template>
          <template v-slot:cell(porcentaje)="row">
            {{ row.item.porcentaje }}%
          </template>
          <template v-slot:cell(action)="row">
            <el-tooltip
              content="Editar Componente"
              placement="top"
              effect="light"
            >
              <b-button
                size="sm"
                class="mr-1 mt-1"
                variant="primary"
                @click.prevent="editarCompo(row.item)"
              ><i class="el-icon-edit"></i
              ></b-button>
            </el-tooltip>
            <el-tooltip
              content="Eliminar Componente"
              placement="top"
              effect="light"
            >
              <b-button
                size="sm"
                class="mr-1 mt-1"
                variant="danger"
                @click.prevent="eliminarCompo(row.item)"
              ><i class="el-icon-delete"></i
              ></b-button>
            </el-tooltip>
          </template>
        </b-table>
      </b-card>
    </b-form-row>

    <!-- Modal CAS -->
    <b-modal id="componente-modal"
             v-model="componente_modal"
             :title="(selectedComponente.accion === 'crear' ? 'Crear' : 'Editar') + ' Componente'"
             size="lg"
    >
      <ModalFormComponentes />

      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="primary" @click="guardarComponente()">
          Guardar
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <hr>
    <FooterButtons back="/fds/listar" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import ModalFormComponentes from "./ModalFormComponentes";

export default {
  name: "FDS-Seccion3",
  components: {
    ModalFormComponentes,
    FooterButtons
  },
  data() {
    return {
      componente_modal: false,
      columnas: [
        {
          key: "compuesto",
          label: "Componente",
          thStyle: {
            "min-width": "200px !important",
            width: "300px !important",
          },
        },
        {
          key: "cas",
          label: "No. Cas",
          thStyle: {
            "min-width": "120px !important",
            width: "120px !important",
          },
        },
        {
          key: "porcentaje",
          label: "Porcentaje",
          thStyle: {
            "min-width": "80px !important",
            width: "80px !important",
          },
        },
        {
          key: "action",
          label: "",
          thStyle: {
            "min-width": "80px !important",
            width: "80px !important",
          },
        },
      ],
    }
  },
  async created() {
    await this.setSeccionActual(3);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
      await this.getComponentesDetalle(id_fds_producto);
    } else {
      await this.resetSeccion();
      await this.resetSelectedComponente();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    async crearComponente() {
      await this.resetSelectedComponente();
      this.componente_modal = true;
    },
    async guardarComponente() {
      if (this.selectedComponente.accion === 'crear') {
        await this.crearComponenteDetalle();
      } else if (this.selectedComponente.accion === 'editar') {
        await this.actualizarComponenteDetalle();
      }
      this.componente_modal = false;
    },
    editarCompo(item) {
      this.selectedComponente.accion = 'editar';
      this.selectedComponente.id = item.id;
      this.selectedComponente.id_empresa = item.id_empresa;
      this.selectedComponente.id_fds_producto = item.id_fds_producto;
      this.selectedComponente.compuesto = item.compuesto;
      this.selectedComponente.cas = item.cas;
      this.selectedComponente.porcentaje = item.porcentaje;
      this.componente_modal = true;
    },
    eliminarCompo(item) {
      let confirm = false;
      Swal.fire({
        text: "¿Desea eliminar el componente?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#097b83',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.borrarComponenteDetalle(item);
        }
      });
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
      'resetSelectedComponente'
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion',
      'getComponentesDetalle',
      'crearComponenteDetalle',
      'actualizarComponenteDetalle',
      'borrarComponenteDetalle'
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'setSelectedComponente',
      'resetSeccion',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion3',
      'selectedComponente',
      'componentes_detalle'
    ])
  }
}
</script>
